import type { ButtonBlock } from '@blogforge/shared';
import type { DragPath } from 'src/types';

export function ButtonRenderer({ block }: { block: ButtonBlock; path: DragPath }) {
  const { variant, href, hrefIsMustache, target } = block.attrs;
  const s = block.style ?? {};

  // Build a CSS style object (React prefers objects over strings)
  const linkStyle: React.CSSProperties = {
    paddingTop: s.paddingTop,
    paddingRight: s.paddingRight,
    paddingBottom: s.paddingBottom,
    paddingLeft: s.paddingLeft,
    backgroundColor: s.backgroundColor,
    backgroundImage: s.backgroundGradient,
    fontSize: s.fontSize,
    fontWeight: s.fontWeight,
    color: s.color,
    textTransform: s.textTransform,
    letterSpacing: s.letterSpacing,
    borderRadius: s.borderRadius,
    borderTopRightRadius: s.borderTopRightRadius,
    borderTopLeftRadius: s.borderTopLeftRadius,
    borderBottomRightRadius: s.borderBottomRightRadius,
    borderBottomLeftRadius: s.borderBottomLeftRadius,
    border: s.border,
    borderColor: s.borderColor,
    boxShadow: s.boxShadow,
  };

  // textAlign belongs on the wrapper, not the inline <a>
  const wrapperStyle: React.CSSProperties = {
    textAlign: s.textAlign,
    marginTop: s.marginTop,
    marginBottom: s.marginBottom,
    marginLeft: s.marginLeft,
    marginRight: s.marginRight,
  };

  // Handle mustache vs literal href
  const resolvedHref = hrefIsMustache ? href : href || '#';

  return (
    <div style={wrapperStyle}>
      <a
        href={resolvedHref}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        className={`doc-button doc-button--${variant}`}
        style={{ ...linkStyle, pointerEvents: 'none' }}
      >
        {block.content || 'Button text'}
      </a>
    </div>
  );
}
